// extracted by mini-css-extract-plugin
export default {"FormStyle":"Search_FormStyle__S9siJ"};